import { ReactIntegration } from '@grafana/faro-react';
import { LogLevel, getWebInstrumentations, initializeFaro, type Faro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

let faro: Faro | undefined;

if (config.TRACING_COLLECTOR && !import.meta.env.DEV) {
  faro = initializeFaro({
    url: config.TRACING_COLLECTOR,

    app: {
      name: 'mousetrap-ui',
      version: config.VERSION,
      environment: config.ENV_ID,
    },

    consoleInstrumentation: {
      disabledLevels: [LogLevel.DEBUG, LogLevel.INFO],
    },

    instrumentations: [
      ...getWebInstrumentations({}),
      new TracingInstrumentation({
        instrumentationOptions: {
          propagateTraceHeaderCorsUrls: [config.BACKEND],
        },
      }),
      new ReactIntegration(),
    ],
  });
}

export default faro;
